/**
 * รหัสสั้นของชุดข้อสอบ — ผู้เรียนพิมพ์เองที่หน้าแรกได้เมื่อสแกน QR ไม่ได้
 * ใช้ร่วมกันทั้ง frontend (normalize ช่องกรอก) และ backend (validate ก่อนลง DB)
 */
/** ตัวอักษรที่ไม่กำกวมเวลาอ่านออกเสียงหรือเขียนมือ — ตัด 0 O 1 I L U ออก */
export const EXAM_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ';
export const EXAM_CODE_GENERATED_LENGTH = 8;
export const EXAM_CODE_MIN_LENGTH = 4;
export const EXAM_CODE_MAX_LENGTH = 16;
/**
 * ทำให้รหัสที่คนพิมพ์มาเทียบกับที่เก็บใน DB ได้เสมอ
 * "mal-2569 a1" → "MAL2569A1" (ตัดขีด ช่องว่าง และตัวอักษรอื่นทิ้ง)
 */
export function normalizeExamCode(input) {
    return input.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
export function isValidExamCode(input) {
    const normalized = normalizeExamCode(input);
    return (normalized.length >= EXAM_CODE_MIN_LENGTH && normalized.length <= EXAM_CODE_MAX_LENGTH);
}
//# sourceMappingURL=exam-code.js.map